import { useFollowXModalStore } from '@/stores/followXModal';
import { XFollowModal } from './XFollowModal';

export function XFollowModalProvider() {
  const open = useFollowXModalStore((s) => s.open);
  const setOpen = useFollowXModalStore((s) => s.setOpen);

  return <XFollowModal open={open} onOpenChange={setOpen} />;
}
